import { CellProps } from "react-table";
import ListTextCell from "src/apps/super-admin/tabs/roles/list/PermissionCell";
import TextCell from "src/components/tables/cells/TextCell";
import { getGenderLabel } from "src/helpers/helpers";
import ActionsCell from "./ActionsCell";
import { AppointmentType } from "./appointment-types";

const useAppointmentTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Name",
      accessor: "clientName",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Phone",
      accessor: "clientPhone",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Service",
      accessor: "service",
      className: "min-w-[150px]",
      Cell: ListTextCell,
    },
    {
      Header: "Staff assigned",
      accessor: "staff",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<AppointmentType>) => (
        <div className="flex items-center justify-center">
          <TextCell value={`${value[0]}`} />
          {value.length > 1 && (
            <span className="text-[#0C8CE9]">
              +<span>{value.length}</span> etc
            </span>
          )}
        </div>
      ),
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: ({ value, row }: CellProps<AppointmentType>) => {
        return <TextCell value={value ?? 0} />;
      },
    },
    {
      Header: "Appointment Date",
      accessor: "appointmentDate",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Time Slot",
      accessor: "timeSlot",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Gender",
      accessor: "clientGender",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<AppointmentType>) => {
        return <TextCell value={getGenderLabel(value) as string} />;
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<AppointmentType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useAppointmentTableColumns;
